import { render, staticRenderFns } from "./stepInfo.vue?vue&type=template&id=64a33e82&scoped=true&"
import script from "./stepInfo.vue?vue&type=script&lang=js&"
export * from "./stepInfo.vue?vue&type=script&lang=js&"
import style0 from "./stepInfo.vue?vue&type=style&index=0&id=64a33e82&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a33e82",
  null
  
)

export default component.exports